import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { MaterialReactTable } from 'material-react-table';
import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
import './CustomInspectionMrt.scss';
import 'react-toastify/dist/ReactToastify.css';
import { useInspectionGridQuery } from "../hooks/useGridQuery"
import CustomSearchTextField from "../components/common/CustomSearchField";
import { getAPIUrl } from "../components/common/helpers";

const StyledPagination = styled('div')(() => ({
  '& .MuiTablePagination-root': {
    justifyContent: 'flex-end !important',
  },
}));
const CustomInspectionMRT = (props) => {
  const { columns, siteComponentDetails } = props;
  const { component_id, site_id } = siteComponentDetails
  console.log(component_id, site_id)
  const rowsPerPage = 5;

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: rowsPerPage,
  });

  const [columnSizing, setColumnSizing] = useState({});
  const [sorting, setSorting] = useState([]);
  const [search, setSearch] = useState({
    columnId: '',
    value: '',
  });

  const sizedColumns = useMemo(() => {
    return columns.map((col) => {
      const sized = { ...col, size: columnSizing[col.accessorKey] ?? col.size ?? 100 };

      // Add custom Cell renderer for SW version comparison
      if (sized.accessorKey === 'current_sw_version') {
        sized.Cell = ({ row }) => {
          const current = row?.original?.current_sw_version;
          const recent = row?.original?.most_recent_sw_version;
          const equal = current != null && recent != null && String(current) === String(recent);
          const bg = equal ? '#E8F5E9' : '#FFEBEE';
          const color = equal ? '#1B5E20' : '#B71C1C';
          const border = equal ? '1px solid #81C784' : '1px solid #EF9A9A';
          const dotBg = equal ? '#4CAF50' : '#F44336';

          return (
            <div className="version-pill" style={{ backgroundColor: bg, color, border }}>
              <span className="version-dot" style={{ backgroundColor: dotBg }} aria-hidden="true" />
              <span>{current ?? ''}</span>
            </div>
          );
        };
      }

      return sized;
    });
  }, [columns, columnSizing]);

  const [columnOrder, setColumnOrder] = useState(columns.map((c) => c.accessorKey));

  const endpoint = getAPIUrl("getAHJDataDetails")

  const params = useMemo(
    () => ({
      filter_page: pagination.pageIndex * rowsPerPage,
      filter_pageSize: rowsPerPage,
      sortField: sorting?.[0]?.id ?? null,
      sortDirection:
        sorting?.[0] === undefined
          ? null
          : sorting[0].desc
            ? 'desc'
            : 'asc',
      ...(search.value
        ? { [search.columnId]: search.value }
        : {}),
      component_type_id: component_id,
      site_id: site_id
    }),
    [
      pagination,
      sorting,
      search,
      rowsPerPage,
      component_id,
      site_id
    ],)

  const {
    data,
    isLoading,
    isFetching,
  } = useInspectionGridQuery({
    queryKey: ['Inspectionmrt', endpoint, params],
    endpoint,
    params,
  });
  //const tableData = data?.data ?? [];
  const tableData = useMemo(() => {
    const rows = data?.data ?? [];
    return rows;
  }, [data]);
  const totalCount = data?.totalRows ?? 0;

  const handleSearch = (value, columnId) => {
    setSearch((prevParams) => ({
      ...prevParams,
      columnId,
      value,
    }));
    setPagination((prevParams) => ({
      ...prevParams,
      pageIndex: 0,
    }));
  };

  const defaultColumn = {
    Filter: ({ column }) => <CustomSearchTextField column={column} handleSearch={handleSearch} />,
  };

  const MainTabletheme = createTheme({
    palette: {
      mode: 'light',
      background: {
        paper: '#ffffff',
      },
    },
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            minWidth: '0',
            width: '0',
            fontWeight: '500',
            color: '#000',
            fontFamily: 'Nunito Sans',
            fontSize: '12px',
            fontStyle: 'normal',
            lineHeight: '20px',
            letterSpacing: '0.25px',
            padding: '0px',
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: '12px',
            fontFamily: 'Nunito Sans',
            fontWeight: '400',
            lineHeight: '24px',
            fontStyle: 'normal',
            letterSpacing: '0.15px',
            color: 'rgba(0, 0, 0, 0.87)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
            boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.3)',
          },
        },
      },
      MuiCollapse: {
        styleOverrides: {
          root: {
            width: '100%',
          },
        },
      },
    },
  });

  const handlePaginationChange = (newPagination) => {
    setPagination(newPagination);
  };


  return (
    <ThemeProvider theme={MainTabletheme}>
      <StyledPagination>
        <MaterialReactTable
          layoutMode="grid"
          columns={sizedColumns}
          data={tableData}
          onColumnSizingChange={setColumnSizing}
          enableRowSelection={false}
          defaultColumn={defaultColumn}
          enableRowExpansion={false}
          enableExpandAll={false}
          enableColumnResizing={true}
          enableDensityToggle={false}
          enableColumnFilterModes={false}
          enableGlobalFilter={false}
          enableColumnFilters={true}
          enableHiding={false}
          enableFullScreenToggle={false}
          enableTopToolbar={false}
          enableColumnActions={false}
          manualPagination={true}
          manualSorting={true}
          onPaginationChange={handlePaginationChange}
          onSortingChange={(sortParameters) => {
            setSorting(sortParameters);
            setPagination((prevParams) => ({
              ...prevParams,
              pageIndex: 0,
            }));
          }}
          rowCount={totalCount}
          state={{
            isLoading: isLoading || isFetching,
            pagination,
            sorting,
            columnOrder,
            columnSizing,
          }}
          onColumnOrderChange={setColumnOrder}
          muiCircularProgressProps={{
            color: '#002376',
            thickness: 2,
            size: 30,
          }}
          muiSkeletonProps={{
            animation: 'pulse',
            height: 28,
          }}
          displayColumnDefOptions={{
            'mrt-row-expand': {
              header: '',
              size: 0,
            },
          }}
          initialState={{
            //showColumnFilters: true,
            density: 'compact',
          }}
          muiTableHeadProps={{
            className: `Header`,
            sx: {
              '& .MuiTableSortLabel-root': {
                opacity: 0,
              },
              '& .Mui-active .MuiTableSortLabel-root': {
                opacity: 1,
              },
            },
          }}
          muiTableBodyProps={{
            className: `Body`,
          }}
          muiPaginationProps={{
            rowsPerPageOptions: [rowsPerPage],
            showFirstButton: true,
            showLastButton: true,
            SelectProps: {
              sx: {
                borderRadius: '4px',
                fontFamily: 'Nunito sans',
                width: '49px',
                height: '30px',
                fontSize: '12px',
                padding: '0px 8px',
                backgroundColor: 'lightgray',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                background: '#fff',
                alignItems: 'center',
              },
            },
          }}
          />
      </StyledPagination>
    </ThemeProvider>
  );
};

CustomInspectionMRT.propTypes = {
  gridKey: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      accessorKey: PropTypes.string.isRequired,
      header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      Cell: PropTypes.func,
      size: PropTypes.number,
      minSize: PropTypes.number,
      maxSize: PropTypes.number,
    }),
  ).isRequired,
};

export default CustomInspectionMRT;